import React from 'react'

const CheckoutErrorContext = React.createContext<{
  setError: (section: string, error: string) => void
  error: {section?: string; error?: string}
  showAnimation: boolean
  clearError: () => void
}>({setError: () => {}, error: {}, clearError: () => {}, showAnimation: false})

export default CheckoutErrorContext
